import { App } from './engine/App';
import { AssetManager } from './engine/Assets';
import { initOhlecHUD } from './ui/ohlecHUD';
import { UIState } from './ui/store';
import { showWipModalIfNeeded } from './ui/wipModal';

async function bootstrapOhlec() {
  console.log('Bootstrapping OHLEC Assessment Mode...');

  // Set the global state so the engine knows not to boot the standard simulator
  UIState.update({ activeMode: 'OHLEC', activeTool: null });

  // Load core textures and assets first
  await AssetManager.loadAll();

  // Initialize UI Bindings for OHLEC
  initOhlecHUD();

  // Hide loading screen
  const loadingScreen = document.getElementById('loading-screen');
  if (loadingScreen) {
    loadingScreen.classList.remove('active');
    setTimeout(() => {
      loadingScreen.style.display = 'none';
    }, 500); // match CSS transition duration
  }

  console.log('Initializing 3D Engine for OHLEC...');
  const app = new App('app-canvas');
  app.init();

  // Start the render and physics loop
  app.run();

  // Start the specific OHLEC assessment mode
  app.startOhlecMode();
  
  showWipModalIfNeeded();
}

bootstrapOhlec().catch(console.error);
